export default {
	'nav.home': 'Home',
	'nav.personal': 'Personal',
	'common.add': 'add',
	'common.create': 'create',
	'common.save': 'save',
	'common.update': 'update',
	'common.view': 'view',
	'common.edit': 'edit',
	'common.delete': 'delete',
	'common.batchDelete': 'Batch deletion',
	'common.search': 'search',
	'common.detail': 'Detail',
	'common.refresh': 'refresh',
	'common.reset': 'reset',
	'common.export': 'export',
	'common.login': 'login',
	'common.logout': 'logout',
	'common.cancel': 'cancel',
	'common.confirm': 'confirm',
	'common.ok': 'ok',
	'common.close': 'close',
	'common.import': 'import',
	'common.reImport': 'Reimport',
	'common.clear': 'Clear',
	'common.themeColor': 'Theme Color',
};
